import React, { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { AppStore } from '../../store/store';
import { UserState } from '../../store/user.slice';

interface AdminGuardProps {
    children: ReactNode;
}

const AdminGuard: React.FC<AdminGuardProps> = ({ children }) => {
    const { user } = useSelector<AppStore, UserState>((state) => state.user);

    const isAdmin = user?.roles?.includes("pg_admin") ?? false;

    if (!isAdmin) {
        return <Navigate to="/app/dashboard" replace />;
    } else {
        return <>{children}</>;
    }
};

export default AdminGuard;
